import getAxios from './axiosService'

const _autoBuyKey = 'kkComicAutoBuy'
const _payPageHistoryKey = 'payPageHistory'

function getAutoBuyList () {
  let list = JSON.parse(window.localStorage.getItem(_autoBuyKey))
  return list ? list : []
}

function setAutoBuyList (list) {
  window.localStorage.setItem(_autoBuyKey, JSON.stringify(list))
}

let payService = {
  setPayPageHistory () {
    window.localStorage.setItem(_payPageHistoryKey, '1')
  },
  needAlertPayWarning () {
    let payPageHistory = window.localStorage.getItem(_payPageHistoryKey)
    let result
    if (payPageHistory == null || payPageHistory == '') {
      result = false
    } else {
      result = (payPageHistory == '1')
    }
    window.localStorage.setItem(_payPageHistoryKey, '0')
    return result
  },
  addAutoBuyList (bookId) {
    let list = getAutoBuyList()
    if (!list.includes(bookId)) {
      list.push(bookId)
      setAutoBuyList(list)
    }
  },
  isAutoBuy (bookId) {
    let id = parseInt(bookId)
    let list = getAutoBuyList()
    return list.includes(id)
  },
  removeAutoBuy (bookId) {
    let list = getAutoBuyList()
    list.splice(list.indexOf(bookId), 1)
    setAutoBuyList(list)
  },
  getPurchaseInfo (appType, router) {
    return new Promise((resolve, reject) => {
      let axios = getAxios()
      axios.get('/api/user/recharge?appType=' + appType)
        .then(res => {
          if (res.status === 200) {
            if (res.data.result) {
              resolve(res.data)
            } else {
              alert(res.data.msg)
              router.push('/user')
            }
          } else {
            reject()
          }
        })
    })
  },
  charge (channel, purpose, amount) {
    return new Promise((resolve, reject) => {
      let axios = getAxios()
      axios.post(`/api/pay/pay`, {}, {
        params: {
          payChannel: channel,
          payPurpose: purpose,
          rechargerAmount: amount
        }
      })
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject()
          }
        })
    })
  },
  applyPay (payUrl) {
    return new Promise((resolve, reject) => {
      let axios = getAxios()
      axios.get(payUrl)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject()
          }
        })
    })
  }
}

export default payService
